export default {
  header: 'Tooling Management',
  groupKey: 'toolingmanagement',
  filters: [

    {
      text: 'Tooling Items',
      value: 'toolingGrid',
    },

    {
      text: 'Add Tooling',
      value: 'addTooling',
    },
    {
      text: 'Download Tooling',
      value: 'downloadTooling',
    },
    {
      text: 'Upload Tooling',
      value: 'uploadTooling',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/config/searchFilters/ToolingManagementFilters.js